<template>
    <div class="automation-trigger-settings">
        <p>
            {{ t('automations-form-triggers_config-specific_date-description') }}
        </p>
        <label>{{ t('automations-form-triggers_config-specific_date-date_label') }} </label>

        <datetime-with-clear
            type="datetime"
            :zone="placeTimezone"
            :value-zone="placeTimezone"
            v-model="date"
        ></datetime-with-clear>
    </div>
</template>
<script>
import DatetimeWithClear from "../../../components/datetime-with-clear/datetime-with-clear.vue";

export default {
    props: {
        value: Array,
    },
    data: function () {
        let date =
            this.value.length > 0 && this.value[0].date
                ? this.value[0].date
                : null;
        return {
            date: date,
        };
    },
    components: {
        "datetime-with-clear": DatetimeWithClear,
    },
    computed: {
        placeTimezone() {
            return (
                (this.$store.state.place && this.$store.state.place.timezone) ||
                "America/Sao_Paulo"
            );
        },
    },
    mounted: function () {
        this.changed();
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        changed: function () {
            this.$emit("input", [{ date: this.date }]);
        },
        isValid: function () {
            return !!this.date;
        },
    },
    watch: {
        date: function () {
            this.changed();
        },
        value: function () {
            let date =
                this.value.length > 0 && this.value[0].date
                    ? this.value[0].date
                    : null;
            if (date !== this.date) {
                this.date = date;
            }
        },
    },
};
</script>
